import clsx from 'clsx';
import { SearchIcon } from '../../common/all-icons/custom-icons';
import styles from './Search.module.scss';
import { useEffect } from 'react';

const Search = ({
  searchInputRef,
  placeholder,
  style,
  value,
  onChange,
  iconStyles = {},
  size = 'large',
  fontClass = 'body-medium',
  ...props
}) => {
  useEffect(() => {
    searchInputRef?.current?.focus && searchInputRef.current.focus();
  }, [searchInputRef?.current]);

  return (
    <div style={{ position: 'relative' }}>
      <SearchIcon style={{ position: 'absolute', top: '13px', left: '16px', zIndex: 9, ...iconStyles }} />
      <input
        ref={searchInputRef}
        placeholder={placeholder || 'Search'}
        value={value}
        onChange={onChange}
        autoComplete="off"
        style={style}
        className={clsx(fontClass, styles.searchInput)}
        size={size}
        {...props}
      />
    </div>
  );
};

export default Search;
